import { useQuery } from "@tanstack/react-query";
import { fetchCompaniesWithoutSubscription } from "../api/fetchCompaniesWithoutSubscription";

export const useCompaniesWithoutSubscription = (filters = {}, enabled = true) => {
  const { data, error, isLoading, refetch } = useQuery({
    queryKey: ["companiesWithoutSubscription", filters],
    queryFn: () => fetchCompaniesWithoutSubscription(filters),
    enabled,
  });

  return {
    data: data?.result || null,
    companies: data?.result?.companies || [],
    pagination: data?.result?.pagination || null,
    error,
    isLoading,
    refetch,
  };
};

